module.exports = __webpack_public_path__ + "img/MATIC.76d5c5c9.svg";